import { getChatPreviews } from "../../../api/messages";
import { GET_CHAT_PREVIEWS } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

/**
 * Fetches a list of chat previews for the current user.
 *
 * @param {number | string} userId - The ID of the current user.
 * @param {number | null} [pollingMs=null] - Optional polling interval in milliseconds.
 */
export const useGetChatPreviews = (userId, pollingMs = null) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_CHAT_PREVIEWS, userId],
    () => getChatPreviews(userId),
    {
      enabled: !!userId,
      refetchInterval: pollingMs ?? false,
    }
  );

  return {
    chatPreviews: data?.data || null,
    previewsLoading: isLoading,
    refetchPreviews: refetch,
  };
};
